// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__edVeE","title":"styles_title__iaDiw","description":"styles_description__RfycV"};
module.exports.__checksum = "2106685ec76c"